<template>
    <div class="login">
        <div class="logo-tit">
            <div class="logo-img">
                <!-- <a href=""> -->
                    <img src="../../assets/newLogo.png" alt="" @click="HandleImgPage">
                <!-- </a> -->
            </div>
            <div class="logo-text">
                欢迎登陆
            </div>
        </div>
        <div class="logo-context">
            <div class="logo-form-box ">
                <div class="form-position">
                    <div class="form_login" >
                        <div v-show="wayType == 1">
                            <div class="form-title-text">
                                <div class="title-tabs title-tab-account" :class="active == 1?'active': ''" @click="getActive(1)">账号登陆</div>
                                <div class="title-tabs"  :class="active == 2?'active': ''" @click="getActive(2)">验证码登陆</div>
                            </div>
                            <div class="logo-input" v-show="loginType == 1">
                                <el-form ref="LoginForm" :model="LoginForm" :rules="rules">
                                    <el-form-item prop="phone">
                                        <el-input v-model="LoginForm.phone" placeholder="请输入手机号/用户名/邮箱">
                                            <i slot="prepend" class="el-icon-user-solid"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item prop="password">
                                        <el-input v-model="LoginForm.password" placeholder="请输入密码" type="password" class="passInput" >
                                            <i slot="prepend" class="el-icon-lock"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form>
                                        <div class="logo-button">
                                            <el-button @click="vsLogin('password')" :loading="loading">登陆</el-button>
                                        </div>
                                    </el-form>
                                </el-form>
                            </div>
                            <div class="logo-input" v-show="loginType == 2">
                                <el-form ref="codeFrom" :model="codeFrom" :rules="rulesCode">
                                    <el-form-item>
                                        <el-input v-model="codeFrom.phone" placeholder="请输入手机号">
                                            <i slot="prepend" class="el-icon-user-solid"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input v-model="codeFrom.code" placeholder="请输入验证码" class="passInput InputWcode"></el-input>
                                        <el-button @click="HandleCode" class="codeInput  InputWcodeWidth"
                                        style="float: right;background: #f2f2f2;color: #666;border: 1px solid #ddd; border-radius: 3px;">获取验证码</el-button>
                                    </el-form-item>
                                    <el-form>
                                        <div class="logo-button">
                                            <el-button @click="vsLogin('smscode')" :loading="loading">登陆</el-button>
                                        </div>
                                    </el-form>
                                </el-form>
                            </div>
                            
                            <div class="login-regist">
                                <div>
                                    <router-link to="/register">
                                        <span class="regist-line">
                                            <i class="regist"></i>
                                            立即注册
                                        </span>
                                    </router-link>
                                </div>
                                <div>
                                    <router-link to="/forgetPassword"> 
                                        <span class="forgetpwd">
                                            忘记密码?
                                        </span>
                                    </router-link>
                                    
                                </div>
                            </div>
                            <div class="third-party" v-if="false">
                                第三方：
                                <img src="../../assets/wechat.png" alt="" @click="getWayType(2)">
                            </div>
                        </div>
                        <div class="impowerBox" v-show="wayType == 2">
                            <div class="title">微信登陆</div>
                            <img src="../../assets/icon_qingchu@2x.png" alt="" class="close" @click="getWayType(1)">
                            <img src="../../assets/wxchat.jpg" alt="" class="qrcode">
                            <div class="info">
                                <p>使用微信扫一扫登录</p>
                                <p>“企链工系统”</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    data(){
        return{
            LoginForm:{
                phone: '',
                password: ''
            },
            rules: {
                phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '请正确输入手机号码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
            },
            rulesCode: {
                phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '请正确输入手机号码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                
            },
            codeFrom:{
                phone: '',
                code: ''
            },
            active: 1,
            loginType: 1,
            wayType: 1,
            login_type: 'password',
            loading: false
        }
    },
    components: {
    },
    methods: {
        // 动态修改font-size
        rem () {
            const docEl = document.documentElement
            window.rem = docEl.getBoundingClientRect().width / 24
            docEl.style.fontSize = window.rem + 'px'
        },
        getActive(val){
            this.active = val
            this.loginType = val
        },
        getWayType(val){
            this.wayType = val
        },
        vsLogin(val){
              
            if(val == 'password'){
                this.$refs.LoginForm.validate((valid) => {
                
                    if (valid) {
                        this.loading = true

                        let loginData = {
                            user_mobile: this.LoginForm.phone,
                            smscode: '',
                            login_type: 'password',
                            user_password: this.LoginForm.password
                        }
                        this.HandleLogin(loginData)
                        
                    } else {
                        console.log('error submit!!');
                        this.loading = false
                        return false;
                    }
                }); 
            }else if(val == 'smscode'){
                this.$refs.codeFrom.validate((valid) => {
                    
                    if (valid) {
                        this.loading = true

                        let codeData = {
                                user_mobile: this.codeFrom.phone,
                                smscode: this.codeFrom.code,
                                login_type: 'smscode',
                                user_password: ''
                            }
                        this.HandleLogin(codeData)
                        
                    } else {
                        console.log('error submit!!');
                        this.loading = false
                        return false;
                    }
                }); 
            }
            
            
                
        },
        HandleLogin(data){
            this.$store.dispatch('login/login',data)
                .then(res => {
                    console.log("登陆登陆登陆");
                    console.log(res);
                    if(res.ok){
                        this.loading = false
                        localStorage.setItem('token', res.data.token)
                        localStorage.setItem("userId",res.data.loginUser.user_id) 
                        localStorage.setItem("phone",res.data.loginUser.user_account) 
                        localStorage.setItem('loginName', res.data.loginUser.name)
                        localStorage.setItem("login",true) 
                        console.log("tokenshuju");
                        console.log(localStorage.getItem("token"));
                        // this.$alert('登陆成功', '提示',{
                        //     confirmButtonText: '确定',
                        // })
                        this.$notify({
                            title: '提示',
                            message: '登陆成功',
                            type: 'success'
                        });

                        this.getPersonalUser()
                        this.loading = false
                        this.$forceUpdate()
                        // this.$router.push('/homePage')
                        this.$router.go(-1);
                    }else{
                        this.$alert(res.msg, '提示',{
                            confirmButtonText: '确定',
                        })
                        this.loading = false
                        }
                }).catch(err => {
                    console.log("失败失败");
                    console.log(err);
                })
        },
        getPersonalUser(){
            let data = {}
            this.$store.dispatch('personal/user',data)
                .then(res => {
                    if(res.ok){
                    
                        var info = res.data
                        var roles = []
                        roles = info.roles
                        sessionStorage.setItem('qiliangongRoles', JSON.stringify(roles))
                        sessionStorage.setItem('qiliangongIsCustUser', info.IsCustUser)
                        sessionStorage.setItem('qiliangongIsExpert', info.IsExpert)

                        
						
                    }
                })
        },
       
        HandleCode(){
            let data = {
                ac: 'appvercode',
                phone: this.codeFrom.phone,
                usecate: "login",
                expireTime: '5'
            }
            this.$store.dispatch('login/sendsms',data)
                .then(res => {
                    if(res.ok){
                        console.log("ces------------------");
                        console.log(res);
                        this.$alert('发送成功', '提示',{
                            confirmButtonText: '确定',
                        })
                    }else{
                        this.$alert(res.msg,'提示',{
                            confirmButtonText: '确定'
                        })
                    }
                })
        },
        HandleImgPage(){
            this.$router.push({
                path: '/homePage'
            })
        }
    },
    mounted(){
        this.rem()
        // 动态监听屏幕尺寸变化从而修改font-size
        window.onresize = () => {
            this.rem()
        }
    }
}
</script>
<style scoped>
a{
    text-decoration: none;
}
.active{
    color: #4095e5;
}
.login{
    width: 100vw;height: 100%;
    background: #fff;
    padding-top: 20px;
    
}
.logo-tit{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0px auto;
}
.logo-img{
    vertical-align: top;
    margin-top: 2px;
    align-items: center;
}
.logo-img img{
    margin-top: 18px;
    cursor: pointer;
}
.logo-text{
    display: inline-block;
    color: #4095e5;
    border-left: 1px solid #dcdcdc;
    margin-top: 18px;
}
.logo-context {
    background: url(../../assets/loginBack.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin-top: 40px;
    position: relative;

}
.logo-form-box {
    height: 100%;
    margin: 0 auto;

}
.form-position{
    float: left;
    margin: 2px 0;
    font-size: 14px;
    background: none;
    border: none;
}
.form_login {
    background-color: #fff;
}
.form-title-text {
    text-align: center;
    color: #666;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
}
.title-tabs {
    width: 50%;
    text-align: center;
    cursor: pointer;
    box-sizing: border-box;
}
.title-tab-account {
    border-right: 2px solid #a5a0a0;
}
.logo-button .el-button{
    height: 50px;
    background: #4095e5;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
    font-size: 22px;
    border-radius: 3px;
    cursor: pointer;
}
.login-regist{
    margin-top: 28px;
    display: flex;
    justify-content: space-between;
}
.regist-line {
    font-size: 14px;
    color: #e50112;
    margin-top: 26px;
    position: relative;
    padding-left: 20px;
}
.regist-line .regist {
    background: url(../../assets/zc_icon.png) no-repeat;
    width: 16px;
    height: 16px;
    position: absolute;
    left: 0px;
    top: 1px;
}
.forgetpwd{
    color: #000;
    margin-top: 26px;
    font-size: 14px;
    cursor: pointer;
}
.impowerBox .title{
    text-align: center;
    font-size: 20px;
}
.close {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
    width: 14px;
}
.impowerBox .qrcode {
    width: 280px;
    border: 1px solid #e2e2e2;
    margin: 15px 0 0 18px;
}
.impowerBox .info {
    width: 280px;
    margin: 20px auto;
    text-align: center;
    padding-top: 7px 14px;
}
.impowerBox .info p {
    font-size: 13px;
}
.third-party{
    margin-top: 10px;
}
.third-party img{
    width: 25px;height: 25px;
}
@media screen and (max-width: 540px) {
	/* 移动端的CSS样式代码 */
   
    .logo-tit{
        width: 90%;height: 40px;
    }
    .logo-img img{
        width: 140px;
    }
    .logo-text{
        font-size: 18px;
        padding: 5px 0px 5px 10px;
    }

    .logo-context {
        height: 400px;
    
    }
    .logo-form-box {
        width: 100%;
    
    }
    /* .form-position{
        width: 350px;
        margin: 40px 0 0 75px;
    } */

    .form_login {
        width: 290px;
        height: 320px;
        position: absolute;
        top: 20px;
        right: 40px;
        padding: 15px 10px;
    }
    .third-party{
        margin-left: 20px;
    }
    .form-title-text {
        width: 260px;
        font-size: 14px;
        margin: 4px 0 0 10px;
    }
    .title-tabs {
        padding-left: 4px;
    }
    .logo-input{
        width: 260px;
        margin: 40px auto;
    }
    .logo-input .el-input{
        height: 30px;
        margin-bottom: 10px;
    }
    .passInput{
        margin-top: -10px;
    }
    .InputWcode{
        width: 150px;
    }
    .InputWcodeWidth{
        width: 95px;
    }
    .logo-button{
        margin-top: 30px;
    }
    .logo-button .el-button{
        width: 260px;
        margin-top: 0px;
    }

    .regist-line {
        margin-left: 15px;
    }
   
    .forgetpwd{
        margin-right: 20px;
    }
    .login-regist{
        margin-top: -30px;
        display: flex;
        justify-content: space-between;
    }

    
}
@media screen and (min-width: 541px) {
    /* pc端的css样式代码 */
    
    
    .logo-tit{
        width: 1200px;height: 58px;
    }
    .logo-img{
        width: 211px;
    }
    .logo-img img{
        width: 200px;height: 60px;
    }
    .logo-text{
        font-size: 24px;
        margin-left: 20px;
        padding: 5px 0px 5px 20px;
    }

    .logo-context {
        min-width: 1200px;
        width: 100%;
        height: 500px;
    }
    .logo-form-box {
        width: 80%;
        position: relative;
        
        
    
    }
    /* .form-position{
        width: 1000px;
        padding: 35px 75px 20px 75px;
    } */

    .form_login {
        width: 320px;
        height: 386px;
        margin-top: 6px;
        position: absolute;
        right: 20px;
        top: 30px;
        padding: 15px 40px;
    }
    .form-title-text {
        width: 84%;
        font-size: 17px;
        margin: 14px auto 0;
    }
    
   
    .logo-input{
        width: 320px;
        margin: 40px auto;
    }
    .logo-input .el-input{
        height: 40px;
    }
    .passInput{
        margin-top: 10px;
    }
    .codeInput{
        margin-top: 10px;
    }
    .InputWcode{
        width: 179px;
    }
    .InputWcodeWidth{
        width: 128px;
    }
    .logo-button .el-button{
        width: 320px;
        margin-top: 20px;
    }
}

</style>